// Mock content for Cloud9 site (frontend-only defaults)

export const marqueeWords = [
  "CARDAMOM", "SUMAC", "SAFFRON", "MENENG\u0130\u00c7", "TAMARIND", "SEV", "GARAM MASALA", "SO\u011eUK KAHVE",
];

export const stats = [
  { count: 2016, format: "year", label: "Founded" },
  { count: 42, suffix: "+", label: "Spices in the pantry" },
  { count: 12850, suffix: "+", label: "Cups poured this year" },
];

export const concepts = [
  {
    cls: "c1",
    native: "Ocak \u2014 The Fire",
    title: "Turkish Grill",
    desc: "Charcoal, hand-minced lamb, and a skewer technique Mehmet still won't fully explain to the kitchen staff. Adana, \u0130skender and lahmacun come off this fire.",
    icon: "fire",
  },
  {
    cls: "c2",
    native: "Masala \u2014 The Spice",
    title: "Indian Kitchen",
    desc: "A tandoor, a spice grinder that runs from 7am, and Priya's grandmother's dal recipe, timed to a 24-hour simmer that never stops on a Saturday.",
    icon: "tandoor",
  },
  {
    cls: "c3",
    native: "Kahve \u2014 The Cup",
    title: "Coffee House",
    desc: "Turkish coffee simmered in sand, filter coffee roasted upstairs on Tuesdays, and a chai recipe that starts every shift, staff included.",
    icon: "cup",
  },
];

export const menuTabs = [
  { id: "coffee", label: "Coffee & Chai" },
  { id: "turkish", label: "Mezze & Grill" },
  { id: "indian", label: "Curry & Tandoor" },
  { id: "sweets", label: "Something Sweet" },
];

export const menuData = {
  coffee: {
    heading: "Kahve & Chai",
    sub: "Brewed at the counter that sits between both kitchens \u2014 where every shift begins.",
    items: [
      { name: "T\u00fcrk Kahvesi", native: "Turkish coffee", desc: "Simmered slow in a copper cezve, poured unfiltered with a square of lokum.", price: "\u00a33.50", tags: ["V"] },
      { name: "Masala Chai", desc: "Black tea simmered with cardamom, cinnamon, ginger and clove, Delhi-style.", price: "\u00a33.20", tags: ["V"] },
      { name: "Meneng\u0131\u00e7 Latte", native: "pistachio-terebinth", desc: "Wild Anatolian terebinth \"coffee,\" steamed with milk \u2014 nutty, naturally caffeine-free.", price: "\u00a34.20", tags: ["V", "GF"] },
      { name: "Filter Kahve", desc: "Single-origin, roasted upstairs every Tuesday, brewed by the cup.", price: "\u00a33.00", tags: ["VG", "GF"] },
      { name: "Karak Chai", desc: "Strong, sweet, evaporated milk chai, heavy on the cardamom.", price: "\u00a33.40", tags: ["V"] },
      { name: "Cardamom Flat White", desc: "Our house flat white, dusted with green cardamom instead of cocoa.", price: "\u00a33.60", tags: ["V", "GF"] },
    ],
  },
  turkish: {
    heading: "Mezze & Ocak Grill",
    sub: "From the charcoal fire and the mezze counter Mehmet still guards personally.",
    items: [
      { name: "Mercimek \u00c7orbas\u0131", native: "lentil soup", desc: "Red lentil soup finished with cumin butter and lemon.", price: "\u00a35.50", tags: ["VG", "GF"] },
      { name: "Meze Sharing Board", desc: "Hummus, ezme, cac\u0131k and muhammara, warm pide for the table.", price: "\u00a312.00", tags: ["V"] },
      { name: "Adana Kebap", desc: "Hand-minced spiced lamb skewer, charcoal grilled, sumac onions.", price: "\u00a314.50", tags: ["GF"] },
      { name: "Lahmacun", desc: "Thin Turkish flatbread with minced lamb, pepper, parsley and lemon.", price: "\u00a39.00", tags: [] },
      { name: "\u0130skender", desc: "Sliced d\u00f6ner over pide, tomato sauce, browned butter, yoghurt.", price: "\u00a315.00", tags: [] },
      { name: "Karn\u0131yar\u0131k", native: "split aubergine", desc: "Baked aubergine split and filled with spiced beef and tomato.", price: "\u00a313.50", tags: ["GF"] },
    ],
  },
  indian: {
    heading: "Curry & Tandoor",
    sub: "From Priya's counter \u2014 the tandoor, the spice grinder, and the dal pot that never rests.",
    items: [
      { name: "Murgh Makhani", native: "butter chicken", desc: "Tandoor chicken in a tomato-butter gravy, finished with fenugreek.", price: "\u00a314.00", tags: ["GF"] },
      { name: "Lamb Rogan Josh", desc: "Kashmiri chilli and yoghurt, slow-braised until it falls off the bone.", price: "\u00a315.50", tags: ["GF"] },
      { name: "Dal Makhani", desc: "Black lentils, butter and cream \u2014 on a 24-hour simmer, always.", price: "\u00a310.00", tags: ["V", "GF"] },
      { name: "Paneer Tikka", desc: "Char-grilled house paneer, peppers, mint chutney.", price: "\u00a311.50", tags: ["V", "GF"] },
      { name: "Tandoori Mixed Grill", desc: "Chicken tikka, seekh kebab and lamb chop, straight from the clay oven.", price: "\u00a318.00", tags: ["GF"] },
      { name: "Biryani", desc: "Basmati, saffron and fried onions, with raita. Chicken or vegetable.", price: "\u00a313.50", tags: [] },
    ],
  },
  sweets: {
    heading: "Something Sweet",
    sub: "Two dessert cabinets, one syrup pan shared between them.",
    items: [
      { name: "Baklava", desc: "Pistachio and filo in orange-blossom syrup.", price: "\u00a35.00", tags: ["V"] },
      { name: "K\u00fcnefe", desc: "Shredded pastry and melting cheese, hot syrup, kaymak on top.", price: "\u00a36.50", tags: ["V"] },
      { name: "Gulab Jamun", desc: "Milk-solid dumplings in cardamom-rose syrup, served warm.", price: "\u00a34.50", tags: ["V"] },
      { name: "Kheer", desc: "Slow-cooked rice pudding, saffron, pistachio.", price: "\u00a34.50", tags: ["V", "GF"] },
      { name: "Lokum Selection", native: "Turkish delight", desc: "House-made, rose and pistachio.", price: "\u00a34.00", tags: ["VG", "GF"] },
    ],
  },
};

export const galleryCards = [
  { n: "01", title: "The Tile Wall", pattern: "pattern-a", img: "https://images.unsplash.com/photo-1511081692775-05d0f180a065?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxjYWZlJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg1MzM0NDUxfDA&ixlib=rb-4.1.0&q=85&w=800" },
  { n: "02", title: "The Tandoor Corner", pattern: "pattern-b", img: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBjdXJyeXxlbnwwfHx8fDE3ODU0OTI3NzR8MA&ixlib=rb-4.1.0&q=85&w=800" },
  { n: "03", title: "The Grill Pass", pattern: "pattern-c", img: "https://images.pexels.com/photos/37028501/pexels-photo-37028501.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=760&w=800" },
  { n: "04", title: "The Spice Shelf", pattern: "pattern-d", img: "https://images.unsplash.com/photo-1757802261964-a8e03ed98981?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxzcGljZSUyMGphcnN8ZW58MHx8fHwxNzg1NDkyNzc0fDA&ixlib=rb-4.1.0&q=85&w=800" },
  { n: "05", title: "The Roastery", pattern: "pattern-e", img: "https://images.unsplash.com/photo-1610632380989-680fe40816c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxjb2ZmZWUlMjBiZWFuc3xlbnwwfHx8fDE3ODU0OTI3NzR8MA&ixlib=rb-4.1.0&q=85&w=800" },
  { n: "06", title: "The Sweet Counter", pattern: "pattern-f", img: "https://images.unsplash.com/photo-1598110750624-207050c4f28c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxiYWtsYXZhJTIwZGVzc2VydHxlbnwwfHx8fDE3ODU0OTI3NzR8MA&ixlib=rb-4.1.0&q=85&w=800" },
];

// Ambient photo for the story panel
export const storyImage = "https://images.unsplash.com/photo-1511081692775-05d0f180a065?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxjYWZlJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg1MzM0NDUxfDA&ixlib=rb-4.1.0&q=85&w=900";
